import React from 'react';
import { ArrowLeft } from 'lucide-react';

const OrganizationDetailsSkeleton = () => {
  return (
    <div className="p-6 w-[80%] h-[90vh] mt-1 space-y-6">
      <button className="p-1.5 hover:bg-gray-100 rounded-full">
        <ArrowLeft className="w-6 h-6 text-black" />
      </button>
      
      {/* Organization Card */}
      <div className="bg-white rounded-lg p-6 shadow-sm">
        <div className="flex items-start gap-6">
          {/* Logo Skeleton */}
          <div className="w-32 h-32 rounded-lg bg-gray-200 animate-pulse" />

          <div className="flex flex-col items-start justify-between h-32">
            {/* Title and Status Badge */}
            <div className="flex items-center gap-3">
              <div className="h-7 w-48 bg-gray-200 rounded animate-pulse" />
              <div className="h-6 w-16 bg-gray-200 rounded-full animate-pulse" />
            </div>

            {/* Validity */}
            <div className="h-5 w-40 bg-gray-200 rounded animate-pulse" />

            {/* Active Projects */}
            <div className="h-5 w-32 bg-gray-200 rounded animate-pulse" />
          </div>
        </div>
      </div>

      {/* Section Title */}
      <div className="h-6 w-40 bg-gray-200 rounded animate-pulse" />

      {/* Organization Details Boxes */}
      <div className="flex flex-col gap-2 items-start justify-start w-full">
        {[...Array(6)].map((_, index) => (
          <div key={index} className="bg-white p-4 rounded-lg shadow-sm w-full">
            <div className="flex flex-col space-y-2">
              {/* Label */}
              <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
              
              {/* Value and Edit Button */}
              <div className="flex items-center justify-between">
                <div className="h-5 w-48 bg-gray-200 rounded animate-pulse" />
                <div className="h-7 w-7 bg-gray-200 rounded-full animate-pulse" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrganizationDetailsSkeleton;